/// <reference path="../../services/command.service.js" />
/// <reference path="../../services/command-execution.service.js" />
const mod = require('../../bahabot.module.js')

function bbCommandStatusController($scope, $filter) {
    this.getTooltip = function() {
        const date = (d) => d ? $filter('date')(new Date(d), 'yyyy-MM-dd HH:mm:ss') : 'N/A';
        switch (this.status) {
            case 'completed': return `Completed at ${date(this.endedAt)}`;
            case 'running': return `Running since ${date(this.startedAt)}`;
            case 'error': return `Errored at ${date(this.endedAt)}`;
            case 'starting': return `Starting since ${date(this.createdAt)}`;
            default: return '';
        }
    }
}

mod.component('bbCommandStatus', {
    templateUrl: 'tpl/bb-command-status.component.html',
    controller: ["$scope", "$filter", bbCommandStatusController],
    bindings: {
        status: '<',
        createdAt: '<',
        startedAt: '<',
        endedAt: '<'
    }
});